import { createPaginationContainer, graphql } from 'react-relay';
import SearchResults from './SearchResults';
import SearchResultsQuery from '../../../routes/SearchResultsQuery';

export default createPaginationContainer(SearchResults,
  {
    viewer: graphql`
      fragment SearchResultsContainer_viewer on User
      @argumentDefinitions(
        count: { type: "Int" },
        cursor: { type: "String" },
        query: { type: "String!", defaultValue: "" }
      ) {
        s_time_zone
        user_event_search(first: $count, after: $cursor, query: $query) @connection(key: "SearchResultsContainer_user_event_search") {
          edges{
            node{
              event {
                id
                title
              }
              booking_status
              start_at
              end_at
              user_event_segments(first: 1){
                edges{
                  node{
                    location
                  }
                }
              }
            }
          }
          pageInfo {
            endCursor
            hasNextPage
          }
        }
      }`
  },
  {
    direction: 'forward',
    getConnectionFromProps(props) {
      return props.viewer && props.viewer.user_event_search;
    },
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount
      };
    },
    getVariables(props, { count, cursor }, fragmentVariables) {
      return {
        count,
        cursor,
        query: fragmentVariables.query
      };
    },
    query: SearchResultsQuery
  }
);



// WEBPACK FOOTER //
// ./webpack/components/App/Search/SearchResultsContainer.js